export type AuthProvider = "azure" | "okta";

export const config = {
  auth: {
    provider: (process.env.REACT_APP_AUTH_PROVIDER as AuthProvider) || "okta",
    scopes: ["openid", "profile", "email"],
    // Okta configuration
    okta: {
      issuer: process.env.REACT_APP_OKTA_ISSUER,
      clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
      redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
      postLogoutRedirectUri:
        process.env.REACT_APP_OKTA_POST_LOGOUT_REDIRECT_URI,
    },
    // Azure AD configuration
    azure: {
      clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
      tenantId: process.env.REACT_APP_AZURE_TENANT_ID,
      redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
      postLogoutRedirectUri:
        process.env.REACT_APP_AZURE_POST_LOGOUT_REDIRECT_URI,
    },
  },
  api: {
    ragChatEndpoint: process.env.REACT_APP_RAG_CHAT_API_ENDPOINT,
    ragUploadEndpoint: process.env.REACT_APP_RAG_UPLOAD_API_ENDPOINT,
    vectorStoreId: process.env.REACT_APP_VECTOR_STORE_ID,
  },
};
